import * as faceapi from '@vladmandic/face-api';

export default async function loadDetection(detection, descriptions) {
  return new faceapi.LabeledFaceDescriptors(detection.guestId, descriptions);
}
